<br>

<div class="col-md-12">
  <app-common-search-view [form]="form" header="Åldersfördelning" [showSpinner]="showSpinner" (createReport)="createReport($event)" (clearReportView)="clearReport()" [multiple]="false">
  </app-common-search-view>
  </div>

<div class="col-md-5">

</div>
<br>
<div *ngIf="agedata?.length > 0" class="ms-4 me-3">
<p-menubar [model]="items">

</p-menubar>
</div>
<div *ngIf="agedata?.length > 0" class="row container" style="width:1200px;margin-left:10px;margin-top:30px;" id="contentToConvert">

  <div style="text-align: right;border-right:1px solid #F0F0F0;width:80px;padding-right:10px;">
    <b>Intervall</b>
    <br>0-19
    <br>20-29
    <br>30-39
    <br>40-49
    <br>50-59
    <br>60-69
    <br>70-79
    <br>80-89
    <br>90-99
    <br>100-109
    <br>Totalt
    <br>Yngst
    <br>Äldst
    <br>Medel
  </div>
  <div class="col-md-10" style="border:1px solid #F0F0F0;">



<div class="d-flex justify-content-start gap-3" style="margin-left:30px;">
  <div *ngFor="let a of agedata; let idx = index" style="width:60px; text-align:center;">
    
    <!-- Årsrubrik -->
    <div class="fw-bold">{{ years[idx] }}</div>

    <!-- Värden per "number" -->
    <div *ngFor="let number of intervalidx">
      <div>{{ newvaluelist[idx][number] }}</div>

      <div *ngIf="number === 9" style="border-top:1px solid black;">
        <b>{{ a.noOfPersons }}</b><br />
        {{ a.youngest }}<br />
        {{ a.oldest }}<br />
        {{ a.average }}
      </div>
    </div>

  </div>
</div>

  </div>
  <div *ngIf="form.get('institutions')?.value.length > 0 || form.get('districts')?.value.length > 0" style="margin-top: 20px;">Åldersfördelning för {{institutionname}}</div>
  <div *ngIf="form.get('lodges')?.value === 'b'" style="margin-top: 20px;">Åldersfördelning totalt Bröder (loger)</div>
  <div *ngIf="form.get('lodges')?.value === 'r'" style="margin-top: 20px;">Åldersfördelning totalt Systrar (loger)</div>
  <div *ngIf="form.get('camps')?.value === 'bl'" style="margin-top: 20px;">Åldersfördelning totalt Bröder (läger)</div>
  <div *ngIf="form.get('camps')?.value === 'rl'" style="margin-top: 20px;">Åldersfördelning totalt Systrar (läger)</div>
  <div style="margin-top: 20px;margin-left:40px;">{{currentDate | date:'yyyy-MM-dd'}}</div><br>

</div>
<!--pre>{{agedistributionform.value | json}}</pre-->
<!--pre>{{agedata | json}}</pre-->

<!--pre>{{newvaluelist|json}}</pre-->
